import { isIndexable } from "./utils.js";
// Migration mapping for old to new field names
const LeningdeelMigration = [
    { old: "Hypotheekvorm" },
    { old: "Rente" },
    { old: "Toetsrente" },
    { old: "Hoogte" },
    { old: "Looptijd" },
    { old: "Rentevast" },
    { old: "Toetslast" },
];
/**
 * Format a numeric value for display
 */
function formatNumeric(value, minimumFractionDigits, maximumFractionDigits, useGrouping = true) {
    let numVal;
    if (typeof value === "number") {
        numVal = value;
    }
    else if (typeof value === "string") {
        // Simple number parsing - replace commas with dots for European format
        const cleanedValue = value.replace(",", ".");
        numVal = Number.parseFloat(cleanedValue);
    }
    if (typeof numVal !== "number" || !Number.isFinite(numVal)) {
        return undefined;
    }
    const out = numVal?.toLocaleString("nl-NL", {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        useGrouping: useGrouping,
    });
    return out;
}
function formatNumericWhole(value, useGrouping = true) {
    return formatNumeric(value, 0, 0, useGrouping);
}
function formatNumericPercentage(value) {
    return formatNumeric(value, 3, 3);
}
export function getMigratedLeningdeel(oldLeningdeel) {
    if (!isIndexable(oldLeningdeel)) {
        throw new Error(`Couldn't parse oldLeningdeel: type must be object, but is ${typeof oldLeningdeel}`);
    }
    const newLeningdeel = {
        id: globalThis.crypto.randomUUID(),
    };
    if ("Box 1" in oldLeningdeel &&
        !oldLeningdeel["Box 1"] &&
        "Hoogte" in oldLeningdeel &&
        (typeof oldLeningdeel.Hoogte === "string" ||
            typeof oldLeningdeel.Hoogte === "number")) {
        newLeningdeel.hoogteBox3 = formatNumericWhole(oldLeningdeel.Hoogte, false);
    }
    for (const { old } of LeningdeelMigration) {
        if (!(old in oldLeningdeel)) {
            continue;
        }
        const oldValue = oldLeningdeel[old];
        let newValue;
        if (old === "Rente") {
            newValue = formatNumeric(oldValue, 0, 3);
        }
        else if (old === "Toetsrente") {
            newValue = formatNumericPercentage(oldValue);
        }
        else if (typeof oldValue === "number") {
            newValue = oldValue.toString();
        }
        else {
            newValue = String(oldValue);
        }
        switch (old) {
            case "Hypotheekvorm":
                newLeningdeel.hypotheekvorm = newValue;
                break;
            case "Rente":
                newLeningdeel.rente = newValue;
                break;
            case "Toetsrente":
                newLeningdeel.toetsrente = newValue;
                break;
            case "Hoogte":
                newLeningdeel.hoogte = newValue;
                break;
            case "Looptijd":
                newLeningdeel.looptijd = newValue;
                break;
            case "Rentevast":
                newLeningdeel.rentevast = newValue;
                break;
            case "Toetslast":
                newLeningdeel.toetslastPerMaand = newValue;
                break;
            default:
                continue;
        }
    }
    return newLeningdeel;
}
